import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { INDUSTRIES, IMAGES } from "@/lib/content";
import { Reveal, Overline } from "@/components/site/Reveal";

const IMGS = [
  IMAGES.commercial,
  IMAGES.hero,
  IMAGES.repair,
  IMAGES.passenger,
];

export default function Industries() {
  const [active, setActive] = useState(0);
  return (
    <section
      id="industries"
      data-testid="industries-section"
      className="bg-white py-24 md:py-32"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12">
        <div className="mb-16 max-w-2xl">
          <Reveal>
            <Overline>Where We Work</Overline>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-5 font-display text-4xl font-bold leading-[1.02] tracking-tighter text-[#0B3A82] sm:text-5xl md:text-6xl">
              Industries we serve.
            </h2>
          </Reveal>
        </div>

        <div className="grid gap-10 lg:grid-cols-[1.1fr_0.9fr]">
          <div className="border-t border-[#0B3A82]/15">
            {INDUSTRIES.map((ind, i) => (
              <Reveal key={ind} delay={0.03 * i}>
                <button
                  data-testid={`industry-${i}`}
                  onMouseEnter={() => setActive(i % IMGS.length)}
                  onFocus={() => setActive(i % IMGS.length)}
                  className="group flex w-full items-center justify-between border-b border-[#0B3A82]/15 py-5 text-left transition-colors hover:pl-3"
                >
                  <span className="flex items-baseline gap-4">
                    <span className="font-body text-xs font-semibold text-[#D89A18]">
                      {String(i + 1).padStart(2, "0")}
                    </span>
                    <span className="font-display text-2xl font-medium tracking-tight text-[#0B3A82] transition-colors group-hover:text-[#D89A18] md:text-3xl">
                      {ind}
                    </span>
                  </span>
                  <span className="font-body text-sm text-[#475569] opacity-0 transition-opacity group-hover:opacity-100">
                    View →
                  </span>
                </button>
              </Reveal>
            ))}
          </div>

          <div className="relative hidden overflow-hidden lg:block" style={{ minHeight: 480 }}>
            <AnimatePresence mode="wait">
              <motion.img
                key={active}
                src={IMGS[active]}
                alt="Industry showcase"
                initial={{ opacity: 0, scale: 1.08 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0 }}
                transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
                className="absolute inset-0 h-full w-full object-cover"
              />
            </AnimatePresence>
            <div className="pointer-events-none absolute inset-0 border border-[#0B3A82]/10" />
          </div>
        </div>
      </div>
    </section>
  );
}
